export enum NewsTypeEnum {
  NEWS = 'NEWS',
  ANNOUNCEMENT = 'ANNOUNCEMENT',
}
